import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router, CanActivate } from '@angular/router';
import { Observable, of } from 'rxjs';
import { AuthService } from '../services/auth.service';

@Injectable({
    providedIn: 'root'
})
export class RolesGuard implements CanActivate{

    constructor(
        private readonly auth: AuthService,
        private readonly router: Router
    ) { }

    /**
	 * Can activate validation.
	 * @param route: ActivatedRouteSnapshot
	 * @param state: RouterStateSnapshot
	 */
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        const currentUrl = state.url;

        switch (this.auth.userRole){
            case 'admin':
                return true;
            case 'staff':
                if (currentUrl !== '/admin/svs/units') {
                    return true;
                }
                break;
            case 'user':
                if (currentUrl === '/admin/svs/media') {
                    return true;
                }
				if (currentUrl === '/admin/svs/units') {
                    return true;
                }
				if (currentUrl === '/admin/svs/groups') {
                    return true;
                }
				if (currentUrl.startsWith('/admin/svs/reels')) {
					return true;
				}
                break;
        }
        this.router.navigate(['dashboard']);
        return false;
    }
}
